export const SETTINGS_TABS = {
    AUDIO: 'audio_tab',
    CALENDAR: 'calendar_tab',
    MORE: 'more_tab',
    MODERATOR: 'moderator-tab',
    NOTIFICATIONS: 'notifications_tab',
    PROFILE: 'profile_tab',
    SHORTCUTS: 'shortcuts_tab',
    VIDEO: 'video_tab',
    VIRTUAL_BACKGROUND: 'virtual-background_tab'
};
/**
 * Default frame rate to be used for capturing screenshare.
 */
export const SS_DEFAULT_FRAME_RATE = 5;
/**
 * Supported framerates to be used for capturing screenshare.
 */
export const SS_SUPPORTED_FRAMERATES = [5, 15, 30];
